import makeStyles from '@material-ui/core/styles/makeStyles';

export default makeStyles(theme => ({
  header: { height: theme.spacing(10) },
}));
